//#region interfaces


//#enum enums
export enum ToolTipArrowType {
    Top = "dynamic-tooltip-arrow-top",
    Bottom = "dynamic-tooltip-arrow-bottom",
    Left = "dynamic-tooltip-arrow-left",
    Right = "dynamic-tooltip-arrow-right",
    TopLeft = "dynamic-tooltip-arrow-topLeft",
    TopRight = "dynamic-tooltip-arrow-topRight",
    BottomLeft = "dynamic-tooltip-arrow-bottomLeft",
    BottomRight = "dynamic-tooltip-arrow-bottomRight"
}